import genericApi from './genericApi';
import ApiResponse from '../models/ApiResponse';

const attachmentsRequestHandler = {

  agreeWithTermsAndConditions: (): Promise<ApiResponse<undefined>> => {
    return genericApi.post(`terms`);
  },
};

export default attachmentsRequestHandler;
